var map = {
	"./baominghaixuan.png": 182,
	"./begin.png": 994,
	"./beian.png": 22,
	"./bg1.png": 398,
	"./dingzi.png": 958,
	"./download.png": 361,
	"./gongzhonghao.jpg": 760,
	"./haixuan.png": 615,
	"./kefu2.png": 251,
	"./lists/baohuang.png": 499,
	"./lists/buyu.png": 983,
	"./lists/doudizhu.png": 405,
	"./lists/gouji.png": 74,
	"./lists/huawendi.jpg": 544,
	"./lists/jiwan.png": 172,
	"./lists/majiang.png": 966,
	"./lists/xiaodi.png": 363,
	"./lists/zhendi.png": 757,
	"./logo.png": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;